import { combineReducers } from "redux";
import { configureStore, Action, ThunkAction } from "@reduxjs/toolkit";
import notificationsReducer from "./notifications";
import alertsReducer from "./alerts";
import capturesReducer from "./captures";
import devicesReducer from "./devicesSlice";
import organizationsReducer from "./organizations";
import userOrganizationsReducer from "./userOrganizations";
import schedulesReducer from "./schedules";
import commandReducer from "./command";
import alertsSlice from "./alertsSlice";
import catalogFilterReducer from "./catalogFilterSlice";
import catalogSelectionReducer from "./catalogSelectionSlice";
import catalogItemsReducer from "./catalogItemsSlice";
import {
  catalogApi,
  captureApi,
  alertApi,
  alertCountsApi,
  trapSiteApi,
  deviceApi,
  detectionApi,
  configApi,
  superuserApi,
  realtimeApi,
} from "../actions";

const reducers = combineReducers({
  [deviceApi.reducerPath]: deviceApi.reducer,
  [trapSiteApi.reducerPath]: trapSiteApi.reducer,
  [alertApi.reducerPath]: alertApi.reducer,
  [catalogApi.reducerPath]: catalogApi.reducer,
  [captureApi.reducerPath]: captureApi.reducer,
  [detectionApi.reducerPath]: detectionApi.reducer,
  [alertCountsApi.reducerPath]: alertCountsApi.reducer,
  [configApi.reducerPath]: configApi.reducer,
  [superuserApi.reducerPath]: superuserApi.reducer,
  [realtimeApi.reducerPath]: realtimeApi.reducer,
  notifications: notificationsReducer,
  alerts: alertsReducer,
  captures: capturesReducer,
  devices: devicesReducer,
  organizations: organizationsReducer,
  userOrganizations: userOrganizationsReducer,
  schedules: schedulesReducer,
  command: commandReducer,
  alertsSlice: alertsSlice,
  catalogFilter: catalogFilterReducer,
  catalogSelection: catalogSelectionReducer,
  catalogItems: catalogItemsReducer,
});

export const store = configureStore({
  reducer: reducers,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(deviceApi.middleware)
      .concat(trapSiteApi.middleware)
      .concat(alertApi.middleware)
      .concat(alertCountsApi.middleware)
      .concat(catalogApi.middleware)
      .concat(captureApi.middleware)
      .concat(detectionApi.middleware)
      .concat(configApi.middleware)
      .concat(superuserApi.middleware)
      .concat(realtimeApi.middleware),
  devTools:
    process.env.REACT_APP_ENV !== "production"
      ? {
          trace: true,
          traceLimit: 25,
        }
      : false,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
